import { useCallback, useState } from 'react';
import { gql } from 'graphql-request';
import { graphQLFetcher } from 'api';
import { User } from 'firebase/auth';
import { authHeaders } from 'utils/authHeaders';

interface UpdateOrderFirebaseUserIdResponse {
  status: number;
  message: string;
}

const useUpdateOrderFirebaseUserId = () => {
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const fetchData = useCallback(
    async (
      urlId: string,
      user: User,
    ): Promise<UpdateOrderFirebaseUserIdResponse> => {
      setIsLoading(true);

      const headers = await authHeaders(user);

      const query = gql`
        query setUpdateOrderFirebaseUserId($urlId: String!) {
          updateOrderFirebaseUserId(urlId: $urlId) {
            status
            message
          }
        }
      `;

      const variables = {
        urlId,
      };

      try {
        const response =
          await graphQLFetcher<UpdateOrderFirebaseUserIdResponse>({
            query,
            variables,
            headers,
          });
        setIsLoading(false);
        const { status, message } = response;
        return {
          status,
          message,
        };
      } catch (err) {
        setIsLoading(false);
        return {
          status: 500,
          message: 'Internal error',
        };
      }
    },
    [],
  );

  return {
    isLoading,
    fetchData,
  };
};

export default useUpdateOrderFirebaseUserId;
